import { forwardRef, useImperativeHandle, useState } from "react";

import "./stylesBetCancelModal.css";

import BlockUserIcon from "../../../../../assets/icons/ic_block-user.svg";

import { CloseOutlined } from "@ant-design/icons";

import { message } from "antd";
import { AppStrings } from "../../../../../utils/constants/AppStrings";
import createPrivateAdminPanelInstance from "../../../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../../../api/ApiRoutes";
import RebetLoader from "../../../../CommonComponents/RebetLoader/RebetLoader";

const BetCancelModal = forwardRef(({ handleCancel, bet, refreshBets }, ref) => {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken
  );

  const [isApiRunning, setIsApiRunning] = useState(false);

  const onCancel = () => {
    handleCancel();
  };

  const handleCancelBet = async () => {
    setIsApiRunning(true);

    const payload = {
      bet_id: bet?.bet_id,
      status: 3,
    };

    console.log("payload", payload);
    try {
      await PrivateAdminPanelInstance.post(API_ROUTES?.SETTLE_PIKKEM_BET, payload);

      message.success(AppStrings.BET_CANCELLED_SUCCESSFULLY);
      refreshBets();
    } catch (error) {
      console.error("Error canceling bet:", error);
      message.error(AppStrings.FAILED_TO_CANCEL_BET);
    } finally {
      setIsApiRunning(false);
      handleCancel();
    }
  };

  return (
    <div className="bet-cancel-modal-container">
      <div className="modal-header">
        <div className="modal-header-title">
          <h2 className="modal-title"> {AppStrings.CANCEL_BET}</h2>
        </div>
        <CloseOutlined onClick={handleCancel} className="close-icon" />
      </div>

      <div className="modal-content">
        <p className="modal-content-title">
          {AppStrings.DO_YOU_REALLY_WANT_TO_CANCEL_THIS_BET}
        </p>
      </div>

      <div className="divider" />
      <div className="modal-footer">
        <div className="buttons">
          <button className="cancel-button" onClick={onCancel} disabled={isApiRunning} >
            {isApiRunning ? <RebetLoader height={"20px"} width={"20px"} /> : AppStrings.NO}
          </button>
          <button className="save-button" onClick={handleCancelBet} disabled={isApiRunning} >
            {isApiRunning ? <RebetLoader height={"20px"} width={"20px"} /> : AppStrings.YES}
          </button>
        </div>
      </div>
    </div>
  );
});

export default BetCancelModal;
